import {RestService} from "@/services/rest/RestService";
import {ReferencePriceSettingsAPIApi} from "@/api/pharma-cpc-mgmt";
import {DpReferencePriceSettingsRestDto} from "@/api/pharma-cpc-mgmt/models";

export class BasePricesRestService extends RestService {

    private apiService: ReferencePriceSettingsAPIApi;

    protected constructor() {
        super();
        this.apiService = new ReferencePriceSettingsAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cpcUrl);
    }

    public async getReferencePriceSettings(): Promise<DpReferencePriceSettingsRestDto> {
        const response =
            await this.apiService.getReferencePriceSettings();
        return response.data;
    }

    public async updateReferencePriceSettings(body: DpReferencePriceSettingsRestDto): Promise<void> {
        await this.apiService.updateReferencePriceSettings(body);
    }
}
